/* eslint-disable import/first */
import legacyConfig from '@bingads-webui-component-legacy/config/index';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import featureInstrumentation from '@bingads-webui-campaign-legacy/instrumentation/index';
import instrumentationConstants from '@bingads-webui-static-legacy/instrumentation/constants';
import instrumentationLegacy from '@bingads-webui-static-legacy/instrumentation/index';
import * as i18nErrors from '@bingads-webui-component-legacy/api-errors-campaign/index';
import preferencesService from '@bingads-webui-component-legacy/preference/service/index';
import locationMap from '@bingads-webui-campaign-legacy/location-targets/view/locationMap';
// eslint-disable-next-line
import _bingads_webui_component_legacy_legacy_router_index from '@bingads-webui-component-legacy/legacy-router/index';
// eslint-disable-next-line
const { legacyRouter } = _bingads_webui_component_legacy_legacy_router_index;
import * as walkme from '@bingads-webui-component-legacy/walkme/directive/index';
import * as adDisplayUrlService from '@bingads-webui-campaign-legacy/crud-ad/service/displayUrl';

export const recommendationsDeps = {
  legacyConfig,
  jsdata,
  featureInstrumentation,
  instrumentationConstants,
  instrumentationLegacy,
  i18nErrors,
  preferencesService,
  // We should remove this dependency in the future as it uses backbone, we need a react version of it
  locationMap,
  legacyRouter,
  walkme,
  adDisplayUrlService,
};
